import map from "../../assets/Rectangle 282.svg"
import map2 from "../../assets/map1.gif"
import img2 from "../../assets/Rectangle 280.svg"
import img3 from "../../assets/mainpic.svg"
import Slide from 'react-reveal/Slide';
import { Link } from "react-router-dom";
const MainPage = () => {
  
    return (
        <div  className="main-page">
        <div>
        <div className="black-strip2 d-none d-md-block" style={{marginRight:"75px"}}></div>
        <div className="main-page-content-box">
          <div className="d-flex justify-content-end justify-content-md-between w-100">
          <div className="ms-4 d-none d-md-block">
          <h2 className="text-end me-5 invisible text-nowrap"><span style={{color:"#00E0FF"}}>K O J A</span>-NAJAFABAD</h2>
          <h3 className="text-end me-5 invisible text-nowrap">کارشناسی جامع املاک نجف آباد</h3>
         <Slide top>
         <div>
         <img alt="" className="main-page-img2" src={map2}  />
         </div>
         </Slide>
          </div>
          <div className="" >
          <h2 className="text-center me-5"><span style={{color:"#00E0FF"}}>K O J A</span>-NAJAFABAD</h2>
          <h3 className="text-center me-5"> <span style={{color:"#00E0FF"}}>ک</span>ارشناسی <span style={{color:"#00E0FF"}}>ج</span>امع <span style={{color:"#00E0FF"}}>ا</span>ملاک نجف آباد</h3>
            <Slide left>
            <img alt="" className="main-page-img1 d-md-none" src={img2} />
            <img alt="" className="main-page-img1 d-none d-md-block " src={img3} />
            <div className="text-end me-3">
            <img alt="" className="d-md-none" width={200} src={map} style={{marginTop:"-30%"}}  />
            </div>
            </Slide>
          </div>
          </div>
          <div className=" mt-2 d-flex justify-content-around align-items-start">
          <div className="mt-2 d-flex">
          <Link to="/inquery">
          <button type="button" className="btn main-page-btn ps-4 pe-4 me-2 me-md-5 ms-md-3">استعلام صورت</button>
          </Link>
          <Link to="/userlogin">
          <button type="button" className="btn main-page-btn ps-4 pe-4 me-2 me-md-5 ms-md-3">درخواست نوبت</button>
          </Link>
          </div>
         
          <div className="text-end pe-3 d-none d-md-block" style={{borderRight : "10px solid #024059"}}>
          <h5>با کجا</h5>
          <h5>تا کجا</h5>
          <h5>تا ناکجا با شماییم</h5>
          </div>
         
          </div>
        </div>
        </div>
            
        </div>
    );
};

export default MainPage;